import { Component, OnInit } from '@angular/core';
import { LessonPlanService } from 'src/app/services/LessonPlan/lesson-plan.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
    selector: 'app-daily-class-planning',
    templateUrl: './daily-class-planning.component.html',
    styleUrls: ['./daily-class-planning.component.css']
})
export class DailyClassPlanningComponent implements OnInit {

    SelectUpload: any;
    DailyClassPlanList = [];
    SubmittedSearch = false;
    Submitted = false;
    AlertMsgItem = '';
    AlertMsg = '';
    ItemList = [];
    SubmittedItem = false;
    SubmittedActual = false;
    ClassList = [];
    SectionList = [];
    SubjectList = [];
    SubjectListSearch = [];
    StaffList = [];
    StaffListSearch = [];
    SectionSearchList = [];


    constructor(private lessonplanservice: LessonPlanService, private lookupservice: LookupService,
        public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    selectUpload(file) {
        this.SelectUpload = file[0];
    }

    SearchModel = {
        ClassID: 0,
        SectionID: 0,
        SubjectID: 0,
        StaffID: 0,
        FromDate: moment(new Date()).format('DD-MMM-YYYY'),
        ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    }

    ClearSearch() {
        this.DailyClassPlanList = [];
        this.SubmittedSearch = false;
        this.SearchModel.ClassID = 0;
        this.SearchModel.SectionID = 0;
        this.SearchModel.SubjectID = 0;
        this.SearchModel.StaffID = 0;
        this.SearchModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
        this.SearchModel.ToDate = moment(new Date()).format('DD-MMM-YYYY');
    };



    GetAllDailyClassPlan() {
        this.spinnerService.show();
        this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
        this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
       
        this.lessonplanservice.GetAllDailyClassPlan(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
            this.DailyClassPlanList = data.DailyClassPlanList;
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
        });
    };

    SaveUpdateModel = {
        DailyClassPlanningID: 0,
        ClassID: 0,
        SectionID: 0,
        SubjectID: 0,
        StaffID: 0,
        SceduledDate: moment(new Date()).format('DD-MMM-YYYY'),
        Topic: '',
        SceduledHomework: '',
        IsBulkUpload: false
    }

    ClearSave() {
        this.Submitted = false;
        this.SaveUpdateModel.DailyClassPlanningID = 0;
        this.SaveUpdateModel.ClassID = 0;
        this.SaveUpdateModel.SectionID = 0;
        this.SaveUpdateModel.SubjectID = 0;
        this.SaveUpdateModel.StaffID = 0;
        this.SaveUpdateModel.SceduledDate = moment(new Date()).format('DD-MMM-YYYY');
        this.SaveUpdateModel.Topic = '';
        this.SaveUpdateModel.SceduledHomework = '';
        this.AlertMsgItem = '';
        this.ItemList = [];
    };


    Edit(item) {
        this.SaveUpdateModel.DailyClassPlanningID = item.DailyClassPlanningID;
        this.SaveUpdateModel.Topic = item.Topic;
        this.SaveUpdateModel.SceduledHomework = item.SceduledHomework;
        this.SaveUpdateModel.SceduledDate = moment(item.SceduledDate).format('DD-MMM-YYYY');
        this.SaveUpdateModel.ClassID = item.ClassID;
        this.GetAllSection();
        this.SaveUpdateModel.SectionID = item.SectionID;
        this.GetAllSubject();
        this.SaveUpdateModel.SubjectID = item.SubjectID;
        this.GetAllTeacher();
        this.SaveUpdateModel.StaffID = item.StaffID;

    };


    SingleItemValidation() {
        for (var i = 0; i < this.ItemList.length; i++) {
            if (this.ItemList[i].SceduledDate == this.SaveUpdateModel.SceduledDate) {
                this.AlertMsg = "Please Chose a Different Date";
                return false
            }
        }
        return true;
    }

    Add() {
        this.SubmittedItem = true;
        if (this.SingleItemValidation()) {
            var item = {
                SceduledDate: this.SaveUpdateModel.SceduledDate,
                Topic: this.SaveUpdateModel.Topic,
                SceduledHomework: this.SaveUpdateModel.SceduledHomework,
            };
            this.ItemList.push(item);
            this.SubmittedItem = false;
            this.AlertMsg = '';
        }
    };

    removeRow(index) {
        this.ItemList.splice(index, 1);
    };


    ValidityState() {
        return this.SaveUpdateModel.ClassID == 0 || this.SaveUpdateModel.SectionID == 0 || this.SaveUpdateModel.SubjectID == 0 || this.SaveUpdateModel.StaffID == 0;
    }


    SaveDailyClassPlan(valid) {
        this.AlertMsgItem = '';
        this.Submitted = true;
        if (valid && !this.ValidityState()) {
            if (this.ItemList.length == 0 && this.SaveUpdateModel.DailyClassPlanningID == 0) {
                this.AlertMsgItem = 'Please add atleat one day plan';
                return;
            }
            this.spinnerService.show();
            this.lessonplanservice.SaveDailyClassPlan(JSON.stringify(this.ItemList), JSON.stringify(this.SaveUpdateModel)).subscribe((data: any) => {
                this.AlertMsgItem = '';
                this.globalHelper.CheckActionStatus(data)

                if (this.SaveUpdateModel.DailyClassPlanningID == 0 && data.webResponse.Status) {
                    this.ClearSave();
                    this.GetAllDailyClassPlan();
                }
                else if (data.webResponse.Status) {
                    this.GetAllDailyClassPlan();
                }

            });
        }
    };

    UploadDailyClassPlan() {
        this.Submitted = true;
        if (!this.ValidityState()) {
            this.spinnerService.show();
            this.Submitted = false;
            this.lessonplanservice.UploadDailyClassPlan(JSON.stringify(this.SaveUpdateModel), this.SelectUpload).subscribe((data: any) => {
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(data);
                if (data.webResponse.Status) {
                    this.ClearSave();
                    this.GetAllDailyClassPlan();
                }

            });
        }
    };



    ActualModel = {
        DailyClassPlanningID: 0,
        SceduledDate: '',
        Topic: '',
        SceduledHomework: '',
        ActualDate: '',
        ActualTopic: '',
        ActualHomework: '',
        Remarks: '',

    }
    ClearActual() {
        this.SubmittedActual = false;
        this.ActualModel.DailyClassPlanningID = 0;
        this.ActualModel.SceduledDate = '';
        this.ActualModel.ActualDate = '';
        this.ActualModel.ActualTopic = '';
        this.ActualModel.Topic = '';
        this.ActualModel.ActualHomework = '';
        this.ActualModel.SceduledHomework = '';
        this.ActualModel.Remarks = '';
    };

    ActualDailyClassPlanning(item) {
        this.ActualModel.DailyClassPlanningID = item.DailyClassPlanningID;
        this.ActualModel.SceduledHomework = item.SceduledHomework;
        this.ActualModel.Topic = item.Topic;
        this.ActualModel.SceduledDate = moment(new Date()).format('DD-MMM-YYYY');
        this.ActualModel.ActualHomework = item.ActualHomework;
        this.ActualModel.ActualTopic = item.ActualTopic;
        this.ActualModel.ActualDate = moment(new Date()).format('DD-MMM-YYYY');
        this.ActualModel.Remarks = item.Remarks;
    };

    SaveActualDailyClassPlan(valid) {
        this.SubmittedActual = true;
        if (valid) {
            this.SubmittedActual = false;
            this.spinnerService.show();
            this.lessonplanservice.SaveActualDailyClassPlan(JSON.stringify(this.ActualModel)).subscribe((data: any) => {
                this.globalHelper.CheckActionStatus(data)
                if (data.webResponse.Status) {
                    this.GetAllDailyClassPlan();
                }

            });
        }
    };
    // Init and Lookup

    GetAllClass() {
        this.lookupservice.GetLookupsList('LPClass', '').subscribe((data: any) => {
            this.ClassList = data.LookupItems;
        });
    };

    GetAllSection() {
        this.SaveUpdateModel.SectionID = 0;
        this.SaveUpdateModel.SubjectID = 0;
        this.SaveUpdateModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SaveUpdateModel.ClassID,

        };
        this.lookupservice.GetLookupsList('LPSection', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SectionList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllSubject() {
        this.SaveUpdateModel.SubjectID = 0;
        this.SaveUpdateModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SaveUpdateModel.ClassID,
            'ItemId1': this.SaveUpdateModel.SectionID,

        };
        this.lookupservice.GetLookupsList('LPSubjectSection', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SubjectList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllClassSubject() {
        this.SearchModel.SubjectID = 0;
        this.SearchModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SearchModel.ClassID,

        };
        this.lookupservice.GetLookupsList('LPSubjectSection', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SubjectListSearch = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllTeacher() {
        this.SaveUpdateModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SaveUpdateModel.ClassID,
            'ItemId1': this.SaveUpdateModel.SectionID,
            'ItemId2': this.SaveUpdateModel.SubjectID,

        };
        this.lookupservice.GetLookupsList('LPTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.StaffList = data.LookupItems;   
            if(this.StaffList!=null && this.StaffList.length==2){
                this.SaveUpdateModel.StaffID=this.StaffList[1].ItemId;
              }         
            this.spinnerService.hide();
        });
    };
    GetAllClassTeacher() {
        this.SearchModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SearchModel.ClassID,
        };
        this.lookupservice.GetLookupsList('LPTeacherClasswise', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.StaffListSearch = data.LookupItems;         
            if(this.StaffListSearch!=null && this.StaffListSearch.length==2){
                this.SearchModel.StaffID=this.StaffListSearch[1].ItemId;
              }
            this.spinnerService.hide();
        });
    };
    GetAllSectionSearch() {
        this.SearchModel.SectionID = 0;
        this.SearchModel.SubjectID = 0;
        this.SearchModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SearchModel.ClassID,

        };
        this.lookupservice.GetLookupsList('LPSection', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SectionSearchList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllSubjectSearch() {
        this.SearchModel.SubjectID = 0;
        this.SearchModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SearchModel.ClassID,
            'ItemId1': this.SearchModel.SectionID,

        };
        this.lookupservice.GetLookupsList('LPSubjectSection', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SubjectListSearch = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllTeacherSearch() {
        this.SearchModel.StaffID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.SearchModel.ClassID,
            'ItemId1': this.SearchModel.SectionID,
            'ItemId2': this.SearchModel.SubjectID,

        };
        this.lookupservice.GetLookupsList('LPTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.StaffListSearch = data.LookupItems;
            if(this.StaffListSearch!=null && this.StaffListSearch.length==2){
                this.SearchModel.StaffID=this.StaffListSearch[1].ItemId;
              }
            this.spinnerService.hide();
        });
    };

    ngOnInit() {

        this.GetAllClass();
        this.GetAllClassSubject();
        this.GetAllClassTeacher();
        this.GetAllDailyClassPlan();
    }

}
